import { render, staticRenderFns } from "./CalcButton.vue?vue&type=template&id=1fc0fba4&scoped=true"
import script from "./CalcButton.vue?vue&type=script&lang=ts"
export * from "./CalcButton.vue?vue&type=script&lang=ts"
import style0 from "./CalcButton.vue?vue&type=style&index=0&id=1fc0fba4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc0fba4",
  null
  
)

export default component.exports